import 'babel-polyfill'
//import 'event-source-polyfill'
import 'classlist-polyfill'
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import common from './store/common'
import router from './store/router'
import VueI18n from 'vue-i18n'
import LangZh from './assets/lang/zh.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import LangEn from './assets/lang/en.js'
// import LangRu from './assets/lang/ru.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'	//轮播插件
Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(common);
Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
import axios from 'axios'
axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios


const i18n = new VueI18n({
  	locale: 'zh', 	//定义默认语言
  	messages:{
  		'zh':LangZh,
        'en':LangZh,
        'ru':LangZh,
  		// 'en':LangEn,
      // 'ru':LangRu,
  	}
});

new Vue({
  	el: '#app',
  	router,
  	i18n,
  	template: '<App/>',
  	components: { App }
}).$mount('#app');

